<template>
  <div class="quantity-toggle">
    <button class="val_decrement" @click="decrement()">
      <i class="fa fa-minus" aria-hidden="true"></i>
    </button>
    <input class="mcashVal" type="text" :value="callingCash" readonly />
    <button class="val_increment" @click="increment()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
export default {
  name: 'McashValue',
  props: ['room_id', 'whatsNewmodelOpen', 'channel', 'callingCash'],
  methods: {
    increment() {
      this.callingCash++
      this.$emit('macashValue', this.callingCash)
    },
    decrement() {
      if (this.callingCash > 1) {
        this.callingCash--
        this.$emit('macashValue', this.callingCash)
      } else {
        this.callingCash = 1
      }
    }
  }
}
</script>
<style></style>
